import React from "react";
import privacy from './privacy_policy.pdf'

const Index = () => {
    return (
    <iframe src={privacy} width='100%' height='1000px' title="Privacy Policy">
    </iframe>)
}

export default Index;